// extracted by mini-css-extract-plugin
export default {"container":"PageLoading_container__foZDS","bg":"PageLoading_bg__FLt2C","wrapper":"PageLoading_wrapper__kS0AC","logo":"PageLoading_logo__0Y1Wh","portion":"PageLoading_portion__Oeszh"};